import * as flights from '../../flights';

export class DepartureArrivalFilterItem {

    departure: RangeFilter = {
        min: 0,
        max: 0,
        rangeMin: 0,
        rangeMax: 0
    }

    arrival: RangeFilter = {
        min: 0,
        max: 0,
        rangeMin: 0,
        rangeMax: 0
    }

    constructor(
        departure: { min: number; max: number; rangeMin: number; rangeMax: number },
        arrival: { min: number; max: number; rangeMin: number; rangeMax: number }
    ) {
        this.departure = departure;
        this.arrival = arrival;
    }
}

export class DepartureArrivalFilter {
    items: DepartureArrivalFilterItem[] = [];

    constructor(flights: flights.FlightModel[]) {
        if (flights.length === 0) {
            return;
        }

        const newItems: DepartureArrivalFilterItem[] = [];

        flights[0].legs.forEach(() => {
            newItems.push(new DepartureArrivalFilterItem(
                { min: 0, max: 0, rangeMin: 0, rangeMax: 0 },
                { min: 0, max: 0, rangeMin: 0, rangeMax: 0 }
            ));
        });

        flights.forEach(f => {
            f.legs.forEach((l, i) => {
                if (newItems[i].departure.min === 0 || newItems[i].departure.min > l.departureDate.unix()) {
                    newItems[i].departure.min = l.departureDate.unix();
                }

                if (newItems[i].departure.max === 0 || newItems[i].departure.max < l.departureDate.unix()) {
                    newItems[i].departure.max = l.departureDate.unix();
                }

                if (newItems[i].arrival.min === 0 || newItems[i].arrival.min > l.arrivalDate.unix()) {
                    newItems[i].arrival.min = l.arrivalDate.unix();
                }

                if (newItems[i].arrival.max === 0 || newItems[i].arrival.max < l.arrivalDate.unix()) {
                    newItems[i].arrival.max = l.arrivalDate.unix();
                }
            });
        });

        newItems.forEach((item) => {
            item.departure.rangeMin = item.departure.min;
            item.departure.rangeMax = item.departure.max;
            item.arrival.rangeMin = item.arrival.min;
            item.arrival.rangeMax = item.arrival.max;
        });

        this.items = newItems;
    }

    get touched(): boolean {
        let result = false;

        this.items.forEach((item) => {
            if (item.departure.rangeMin !== item.departure.min
                || item.departure.rangeMax !== item.departure.max
                || item.arrival.rangeMin !== item.arrival.min
                || item.arrival.rangeMax !== item.arrival.max) {
                result = true;
            }
        });

        return result;
    }

    clear() {
        this.items.forEach((item) => {
            item.departure.rangeMin = item.departure.min;
            item.departure.rangeMax = item.departure.max;
            item.arrival.rangeMin = item.arrival.min;
            item.arrival.rangeMax = item.arrival.max;
        });
    }

    check(flight: flights.FlightModel): boolean {
        for (let i = 0; i < flight.legs.length; i++) {
            if (this.items[i].departure.min !== this.items[i].departure.max
                && (this.items[i].departure.min !== this.items[i].departure.rangeMin
                    || this.items[i].departure.max !== this.items[i].departure.rangeMax)) {
                if (flight.legs[i].departureDate.unix() < this.items[i].departure.rangeMin) {
                    return false;
                }

                if (flight.legs[i].departureDate.unix() > this.items[i].departure.rangeMax) {
                    return false;
                }
            }

            if (this.items[i].arrival.min !== this.items[i].arrival.max
                && (this.items[i].arrival.min !== this.items[i].arrival.rangeMin
                || this.items[i].arrival.max !== this.items[i].arrival.rangeMax)) {
                if (flight.legs[i].arrivalDate.unix() < this.items[i].arrival.rangeMin) {
                    return false;
                }

                if (flight.legs[i].arrivalDate.unix() > this.items[i].arrival.rangeMax) {
                    return false;
                }
            }
        }

        return true;
    }
}

interface RangeFilter {
    min: number;
    max: number;
    rangeMin: number;
    rangeMax: number;
}
